import { Announced, classNamesFunction, css, IconButton, Link, Stack, StackItem, Text } from '@fluentui/react';
import React from 'react';
import { SvgIconButtonShim } from '@coherence-design-system/icon';
import { getSlides } from './FeedCarousel.utilities';
var getClassNames = classNamesFunction();
export var FeedCarouselBase = function (props) {
    var _a, _b;
    var styles = props.styles, theme = props.theme, width = props.width, cardsPerSlide = props.cardsPerSlide, responsive = props.responsive, itemWidth = props.itemWidth, prevItemAriaLabel = props.prevItemAriaLabel, nextItemAriaLabel = props.nextItemAriaLabel, _c = props.announceStartMessage, announceStartMessage = _c === void 0 ? 'Showing cards' : _c;
    var classNames = getClassNames(styles, {
        theme: theme,
        responsive: responsive,
        cardsPerSlide: cardsPerSlide,
        itemWidth: itemWidth
    });
    var itemCount = props.items.length;
    var defaultItemWidth = itemWidth ? Math.floor(width / itemWidth) : 0;
    var defaultCardsPerSlide = itemWidth && !responsive ? (defaultItemWidth ? defaultItemWidth : 1) : cardsPerSlide;
    var _d = React.useState(itemCount <= defaultCardsPerSlide), isLastSlide = _d[0], setIsLastSlide = _d[1];
    var _e = React.useState(true), isFirstSlide = _e[0], setIsFirstSlide = _e[1];
    var _f = React.useState(0), currentSlide = _f[0], setCurrentSlide = _f[1];
    var _g = React.useState(0), scrollPosition = _g[0], setScrollPosition = _g[1];
    var _h = React.useState(0), lastNumFocus = _h[0], setLastNumFocus = _h[1];
    var translateScrollPosition = { transform: "translate(".concat(scrollPosition, "%, 0px)") };
    var firstCardIndex = currentSlide * defaultCardsPerSlide + 1;
    var lastCardIndex = Math.min((currentSlide + 1) * defaultCardsPerSlide, itemCount);
    var announcementMessage = "".concat(announceStartMessage, " ").concat(firstCardIndex, " to ").concat(lastCardIndex, " of ").concat(itemCount);
    var resetCarousel = function () {
        setScrollPosition(0);
        setIsFirstSlide(true);
        setCurrentSlide(0);
        setIsLastSlide(itemCount <= defaultCardsPerSlide);
    };
    React.useEffect(function () {
        resetCarousel();
    }, [defaultCardsPerSlide]);
    var cal = itemCount / defaultCardsPerSlide - 1;
    var numberOfSlides = Math.floor(Number.isInteger(cal) ? cal : cal + 1);
    var slideWidth = 100;
    var handleLeftClick = function () {
        if (currentSlide != 0) {
            var newSlide = currentSlide - 1;
            setIsLastSlide(false);
            setCurrentSlide(newSlide);
            setScrollPosition(scrollPosition + slideWidth);
            setIsFirstSlide(newSlide == 0);
        }
    };
    var handleRightClick = function () {
        if (currentSlide !== numberOfSlides) {
            var newSlide = currentSlide + 1;
            setIsFirstSlide(false);
            setCurrentSlide(newSlide);
            setScrollPosition(scrollPosition - slideWidth);
            setIsLastSlide(newSlide === numberOfSlides);
        }
    };
    var current = props.currentFocusElement ? props.currentFocusElement : 0;
    var carouselItemCount = defaultCardsPerSlide;
    if (lastNumFocus < current && current % carouselItemCount === 0) {
        handleRightClick();
        setLastNumFocus(current);
    }
    else if (lastNumFocus > current && (current + 1) % carouselItemCount === 0) {
        handleLeftClick();
        setLastNumFocus(current);
    }
    var slides = getSlides(props === null || props === void 0 ? void 0 : props.items, defaultCardsPerSlide);
    var defaultCardWidth = itemWidth ? itemWidth : defaultCardsPerSlide / 100;
    var widthOfItems = defaultCardsPerSlide * defaultCardWidth;
    var padding = width && !responsive ? (width - widthOfItems) / 2 : 0;
    var slideContainerStyles = {
        root: {
            width: "".concat(width, "px"),
            padding: "0 ".concat(padding, "px"),
            boxSizing: 'border-box'
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames.headerContainer },
            React.createElement(Text, { as: 'h2', className: classNames.header }, props.header),
            React.createElement(Announced, { message: announcementMessage }),
            React.createElement("div", { className: (_a = classNames.supplementContainer) !== null && _a !== void 0 ? _a : classNames.supplimentContainer },
                props.viewAllLink !== undefined && props.viewAllLink !== null && (React.createElement(Link, { as: 'a', className: classNames.viewAllLink, href: props.viewAllLink, onClick: props.viewAllOnClick }, (_b = props.viewAllText) !== null && _b !== void 0 ? _b : "View all ".concat(itemCount))),
                itemCount && (React.createElement("div", { className: classNames.buttonContainer },
                    React.createElement(SvgIconButtonShim, { className: classNames.leftButton, svgIconsEnabled: theme === null || theme === void 0 ? void 0 : theme.svgIconsEnabled, buttonAs: IconButton, "data-testid": "".concat(props.header, "-leftArrow"), iconProps: { iconName: 'ChevronLeft' }, disabled: isFirstSlide, onClick: handleLeftClick, ariaLabel: prevItemAriaLabel !== null && prevItemAriaLabel !== void 0 ? prevItemAriaLabel : 'Previous' }),
                    React.createElement(SvgIconButtonShim, { className: classNames.rightButton, svgIconsEnabled: theme === null || theme === void 0 ? void 0 : theme.svgIconsEnabled, buttonAs: IconButton, "data-testid": "".concat(props.header, "-rightArrow"), iconProps: { iconName: 'ChevronRight' }, disabled: isLastSlide, onClick: handleRightClick, ariaLabel: nextItemAriaLabel !== null && nextItemAriaLabel !== void 0 ? nextItemAriaLabel : 'Next' }))))),
        React.createElement("div", { className: classNames.scrollContainer, "data-test-id": "carousel" },
            React.createElement("div", { className: classNames.scroll, style: translateScrollPosition },
                React.createElement(Stack, { horizontal: true, className: classNames.cardContainer, "aria-live": "polite" }, slides === null || slides === void 0 ? void 0 : slides.map(function (slide, index) {
                    return (React.createElement(StackItem, { className: classNames.slideContainer, key: index, styles: slideContainerStyles, "aria-hidden": index !== currentSlide },
                        React.createElement(StackItem, { className: classNames.slide, key: index }, slide.map(function (item, index2) { return (React.createElement(StackItem, { className: css(classNames.card), key: index2 }, item)); }))));
                }))))));
};
//# sourceMappingURL=FeedCarousel.base.js.map